import { useState } from "react";
import { DatePicker, Select, InputNumber, Button, Image, Form } from "antd";
import dayjs from "dayjs";
import "antd/dist/reset.css"; // reset antd styles
import hotelCategory from "../assets/images/holidayBanner2.jpg";
import PriceRangeDropdown from "./PriceRangeDropdown.jsx";
import RoomsGuestsDropdown from "./RoomsGuestsDropdown.jsx";
import CustomDateRange from "./CustomDateRange.jsx";
import TravelDateDisplay from "./TravelDateDisplay.jsx";

const { RangePicker } = DatePicker;
const { Option } = Select;

export default function HolidaySearchBanner() {
  const [formData, setFormData] = useState({
    country: "UAE",
    city: "Dubai",
    checkIn: dayjs("2025-08-10"),
    checkOut: dayjs("2025-08-11"),
    rooms: 1,
    guests: 2,
    price: [2500, 5000],
  });

  return (
    <div className="relative min-h-[562px] bg-cover bg-center flex items-center justify-center">
      <div className="absolute z-10 inset-0 bg-black/10" />
      <Image
        preview={false}
        className="!w-screen !h-[562px]"
        src={hotelCategory}
      />
      {/* White Card */}
      <div className="container absolute bottom-24 z-20">
        <Form
          layout="vertical"
          className="mt-8 flex gap-4 border rounded-md bg-white shadow-md px-4"
        >
          {/* Country */}
          <Form.Item
            name="country"
            label="Select Country"
            className="m-0 font-medium border-r py-4 flex-1"
          >
            <Select
              defaultValue={formData.country}
              bordered={false}
              size="large"
              className="w-full custom-select text-primary"
            >
              <Option value="UAE">UAE</Option>
              <Option value="Thailand">Thailand</Option>
              <Option value="USA">USA</Option>
              <Option value="France">France</Option>
            </Select>
          </Form.Item>

          {/* City */}
          <Form.Item
            name="city"
            label="Select City"
            className="font-medium m-0 py-4 border-r flex-1"
          >
            <Select
              defaultValue={formData.city}
              bordered={false}
              size="large"
              className="w-full custom-select text-danger"
            >
              <Option value="Dubai">Dubai</Option>
              <Option value="Bangkok">Bangkok</Option>
              <Option value="New York">New York</Option>
              <Option value="Paris">Paris</Option>
            </Select>
          </Form.Item>

          {/* Check-In / Check-Out */}
          <Form.Item
            name="dateRange"
            className="m-0 font-medium py-4 border-r flex-1"
          >
            <TravelDateDisplay />
          </Form.Item>

          {/* Rooms & Guests */}
          <Form.Item label="" className="m-0 font-medium py-4 border-r flex-1">
            <RoomsGuestsDropdown />
          </Form.Item>

          <Form.Item className="flex-1 items-center !mb-0 flex justify-center">
            <Button
              type="danger"
              size="middle"
              className="rounded-full px-14 py-7 shadow-md text-lg font-medium flex-1 
             bg-danger hover:bg-red-700 border-none 
             text-white w-fit"
            >
              Search
            </Button>
          </Form.Item>
        </Form>
      </div>
    </div>
  );
}
